/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Group, Modal, Switch, Text, TextInput } from "@mantine/core";
import { generateClient, GraphQLQuery, put } from "aws-amplify/api";
import {
  fetchAuthSession,
  getCurrentUser,
  GetCurrentUserOutput
} from "aws-amplify/auth";
import { useEffect, useState } from "react";
import {
  UpdateTemplateSectionInput,
  UpdateTemplateSectionMutation,
  UpdateTemplateSectionMutationVariables
} from "../../../API";
import { updateTemplateSection } from "../../../graphql/mutations";
import ConfirmDeleteModal from "./ConfirmDeleteModal";
const client = generateClient();

type addNewSectionTemplateProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  template: any;
  sectionEdit: any;
  fetchTemplate: (templateId: string) => void;
};

const EditSectionTemplateModal = (props: addNewSectionTemplateProps) => {
  const { modalOpened, setModalOpened, fetchTemplate, template, sectionEdit } =
    props;
  const [errorMsg, setErrorMsg] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sectionSimple, setSectionSimple] = useState<boolean>(false);
  const [modalDeleteOpened, setModalDeleteOpened] = useState<boolean>(false);
  useEffect(() => {
    if (sectionEdit) {
      setSectionName(sectionEdit.name);
      setSectionSimple(sectionEdit.isSimple);
    }
  }, [sectionEdit]);
  const handleEditSection = async () => {
    setIsLoading(true);
    try {
      const updateSectionInput: UpdateTemplateSectionInput = {
        id: sectionEdit.id,
        _version: sectionEdit._version,
        name: sectionName,
        isSimple: sectionSimple
      };
      const updateSectionVars: UpdateTemplateSectionMutationVariables = {
        input: updateSectionInput
      };
      const updateSectionResult = await client.graphql<
        GraphQLQuery<UpdateTemplateSectionMutation>
      >({ query: updateTemplateSection, variables: updateSectionVars });
      console.log(updateSectionResult);
      setIsLoading(false);
      fetchTemplate(template.id);
      closeAndResetModal();
    } catch (err) {
      console.log("error edit section:", err);
      setIsLoading(false);
    }
  };
  const handleDeleteSection = () => {
    setModalOpened(false);
    setModalDeleteOpened(true);
  };
  const deleteSectionRequest = async () => {
    setIsLoading(true);
    const user: GetCurrentUserOutput = await getCurrentUser();
    const { identityId } = await fetchAuthSession();
    console.log("userInfo: ", user);
    const init: any = {
      response: true,
      headers: {},
      body: {
        templateSection: sectionEdit,
        username: user.username,
        userIdentityId: identityId,
        isSimple: sectionEdit.isSimple
      }
    };
    try {
      const deleteTemplateSubsectionResult = put({
        apiName: "DeleteTemplateSection",
        path: `/templatesection/${sectionEdit.id}`,
        options: init
      });
      console.log(
        "deleteTemplateSection success: ",
        await deleteTemplateSubsectionResult.response
      );
    } catch (err) {
      console.log("deleteTemplateSection error: ", err);
    }
    fetchTemplate(template.id);
    setIsLoading(false);
    closeAndResetModal();
  };

  const closeAndResetModal = () => {
    setModalOpened(false);
    setModalDeleteOpened(false);
    setErrorMsg("");
  };
  return (
    <>
      <Modal
        opened={modalOpened}
        onClose={closeAndResetModal}
        title="Edit section"
      >
        <TextInput
          label="Name"
          placeholder="Enter template section"
          value={sectionName}
          onChange={(event) => setSectionName(event.target.value)}
          required
        />
        {errorMsg && (
          <Text fz={14} fw={400} c={"red"}>
            {errorMsg}
          </Text>
        )}
        <Switch
          checked={sectionSimple}
          fw={600}
          my={10}
          labelPosition="left"
          label="Simple section"
          onChange={(e) => setSectionSimple(e.currentTarget.checked)}
        />

        <Group mt="md">
          <Group mt="md">
            <Button loading={isLoading} onClick={handleEditSection}>
              Save
            </Button>
            <Button
              color="red"
              loading={isLoading}
              onClick={handleDeleteSection}
            >
              Delete
            </Button>
          </Group>
        </Group>
      </Modal>
      <ConfirmDeleteModal
        modalOpened={modalDeleteOpened}
        title={"Delete section"}
        body={"Are you sure you want to delete this section?"}
        setModalOpened={setModalDeleteOpened}
        onDelete={deleteSectionRequest}
      />
    </>
  );
};
export default EditSectionTemplateModal;
